export default __webpack_public_path__ + "static/media/pdf_icon.9ad34a1d.svg";